import { CheckoutRequest } from '../../models/checkout/checkout-request.interface';
import { mockCheckoutPayload } from './checkout-payload.mock';

export const mockCheckoutRequest: CheckoutRequest = {
  overrideAchDiscountCode: 'D50P2M',
  overrideCCDiscountCode: 'D50P2M',
  retailerDomain: 'amana.com',
  payload: mockCheckoutPayload,
};
